const DEFAULT_SERVER_APP_DOMAIN = 'http://localhost:8800'

const rawServerAppDomain = process.env.REACT_APP_SERVER_APP_DOMAIN || DEFAULT_SERVER_APP_DOMAIN

export const SERVER_APP_DOMAIN = rawServerAppDomain

export const SERVER_BASE_URL = rawServerAppDomain.endsWith('/')
  ? rawServerAppDomain
  : `${rawServerAppDomain}/`

export const WEBSOCKET_URL = process.env.REACT_APP_WEBSOCKET_URL || rawServerAppDomain
